import React from "react";
import { toast } from "react-toastify";
import Text from "../Text";

import styled from "styled-components";

const id = new Date().getMilliseconds();

const ToastContainerHide = styled.div`
  display: none;
`;

export default (props) => {
  const [show, setShow] = React.useState(false);

  function handleShow() {
    if (props.show === true) {
      setShow(true);
      let config = {
        position: props.position ? props.position : "top-center",
        toastId: props.id ? props.id : `toast-${id}`,
      };
      if (toast[props.type]) {
        toast[props.type](
          <Text color="white" fontSize="1.2em">
            {props.message}
          </Text>,
          config
        );
      } else {
        toast.info(
          <Text color="white" fontSize="1.2em">
            {props.message}
          </Text>,
          config
        );
      }
    } else {
      toast.dismiss(`toast-${id}`);
      setShow(false)
    }
  }
  React.useEffect(handleShow, [props.show]);
  return <ToastContainerHide />;
};



// WEBPACK FOOTER //
// ./src/_components/Toast/index.jsx